import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { getProjects } from '@/utils/api';
import { useSettings } from '@/context/SettingsContext';

export const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const { settings } = useSettings();

  const primaryColor = settings?.theme?.primaryColor || '#1e3a5f';

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const data = await getProjects();
      setProjects(data);
    } catch (error) {
      console.error('Failed to load projects:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-safe py-20">
        <div className="text-center text-slate-600">Cargando proyectos...</div>
      </div>
    );
  }

  return (
    <main className="container-safe py-14 md:py-20">
      <div className="mx-auto max-w-3xl text-center">
        <div className="text-xs font-semibold tracking-widest text-slate-500">PROYECTOS</div>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 md:text-4xl">
          Nuestros desarrollos
        </h1>
        <p className="mt-3 text-base leading-relaxed text-slate-600">
          Explorá nuestros proyectos en desarrollo, en obra y ya entregados.
        </p>
      </div>

      <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {projects.map((project) => {
          const firstImage = project.media?.images?.[0]?.url || '/placeholder.jpg';
          return (
            <Link
              key={project.slug}
              to={`/proyectos/${project.slug}`}
              className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-soft hover:shadow-md transition-shadow"
              data-testid={`project-card-${project.slug}`}
            >
              <div className="aspect-video overflow-hidden bg-slate-100">
                <img
                  src={firstImage}
                  alt={project.nombre}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="mb-2 inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-1 text-xs font-semibold" style={{ color: '#9A9A9A' }} data-testid={`project-status-${project.slug}`}>
                  {project.estado === 'Personalizado' && project.estadoCustom ? project.estadoCustom : project.estado}
                </div>
                <h3 className="text-xl font-semibold text-slate-900">{project.nombre}</h3>
                <div className="mt-2 flex items-center gap-2 text-sm text-slate-600">
                  <MapPin size={14} />
                  {project.ubicacion}
                </div>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  {project.descripcionCorta}
                </p>
                <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: primaryColor }}>
                  Ver detalles <ArrowRight size={16} />
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      {projects.length === 0 && (
        <div className="mt-12 text-center text-slate-600">
          No hay proyectos disponibles en este momento.
        </div>
      )}
    </main>
  );
};
